import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeotabService {

  constructor(
    private http: HttpClient
  ) { }

  geotabSession(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/geotab/session');
  }

  getBusDetails(vehicleId): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/api/v1/vehicle-info?vid=${vehicleId}`);
  }
}
